import React from 'react';
import clsx from 'clsx';
import { APP_COLORS } from '@/config/colors';

export interface PaymentAlertProps {
  className?: string;
  /**
   * E-mail kontaktowy marki (z API), na który klient ma wysłać potwierdzenie
   * przelewu. Gdy brak — adres nie jest pokazywany.
   */
  contactEmail?: string;
}

export const PaymentAlert: React.FC<PaymentAlertProps> = ({
  className,
  contactEmail,
}) => {
  return (
    <div className="container mt-12">
      <div
        className={clsx(
          'overflow-hidden rounded-[10px] border-2 border-solid pb-5 font-archivo text-lg font-bold tracking-[0.18px]',
          className,
        )}
        style={{ borderColor: APP_COLORS.red[800] }}
      >
        <div
          className="flex w-full flex-wrap items-center gap-4 px-5 py-4 md:px-9"
          style={{
            backgroundColor: APP_COLORS.red[800],
            color: APP_COLORS.red[200],
          }}
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="my-auto flex-shrink-0 self-stretch"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 0C6.268 0 0 6.268 0 14C0 21.732 6.268 28 14 28C21.732 28 28 21.732 28 14C28 6.268 21.732 0 14 0ZM15.4 20.3C15.4 19.5268 14.7732 18.9 14 18.9C13.2268 18.9 12.6 19.5268 12.6 20.3C12.6 21.0732 13.2268 21.7 14 21.7C14.7732 21.7 15.4 21.0732 15.4 20.3ZM12.6 7.7V15.4C12.6 16.1732 13.2268 16.8 14 16.8C14.7732 16.8 15.4 16.1732 15.4 15.4V7.7C15.4 6.9268 14.7732 6.3 14 6.3C13.2268 6.3 12.6 6.9268 12.6 7.7Z"
              fill={APP_COLORS.red[200]}
            />
          </svg>
          <span className="my-auto flex-1 flex-shrink basis-0">
            Nie odnotowaliśmy jeszcze wpłaty za to zamowienie
          </span>
        </div>
        <div className="mt-4 px-5 text-text-primary md:px-9">
          <p className="w-full text-base font-normal leading-7">
            <span>
              W celu przyspieszenia realizacji wyślij nam potwierdzenie przelewu
              drogą mailowa
            </span>
            {contactEmail && (
              <>
                <span> na adres </span>
                <span style={{ color: APP_COLORS.red[800] }}>
                  {contactEmail}
                </span>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
